import {rpAppLink} from "@pg-mono/rp-routes";

export const getCityLink = (slug: string) => {
    return rpAppLink.prices.flats.city({regionSlug: slug});
};
import {rpAppLink} from "@pg-mono/rp-routes";

export const getCityLink = (slug: string) => {
    return rpAppLink.prices.flats.city({regionSlug: slug});
};
